import React, { useEffect, useState, useContext } from 'react'
import { Helmet } from 'react-helmet';
// import { UserContexto } from '../app';
import { Button, Grid, Input, TextField, Paper, Container, Typography, Box, Autocomplete } from '@mui/material';
import Loader from '../components/loader';
import { useParams, useNavigate } from 'react-router-dom';
import * as endPoints from '../assets/js/endpoints'
import ErrorAlert from '../components/errorAlert';
import SucessAlert from '../components/sucessAlert';
import { styled } from '@mui/material/styles';
import { UserContext } from '../assets/contexts/userContext';
import { useNotification } from '../assets/contexts/notificationContext';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';



const ColorButton = styled(Button)(({ theme }) => ({
  color:'#F7F9FA',
  // color: theme.palette.getContrastText('#95D9C9'),
  backgroundColor: '#95D9C9',
  '&:hover': {
      color:'#45BCAC',
    backgroundColor: '#E9EBEE',
  },
}));
  
function CreateArticle() {
// ID de la noticia del blog, solo se usa en caso de edicion
  const {id} = useParams();
  const context = useContext(UserContext);
  const [title, setTitle] = useState('');
  const [text, setText] = useState('');
  const [image, setImage] = useState(null);
  const [services, setServices] = useState([]);
  const [serviceId, setServiceId] = useState('');
  const [ownerId, setOwnerId] = useState('');
  const [loading, setLoading] = useState(false);
  const { showNotification } = useNotification();


  
  const navigate = useNavigate();

  async function getServices (){
    let servs = await endPoints.getAllServices();
    setServices(servs);
  }

  async function deleteArticle(){
    setLoading(true);
    let resp = await endPoints.deleteArticle(id);
    setLoading(false);
    if(resp !== null){
     showNotification('Noticia eliminada con exito', 'success');
      setTimeout(() => {
        navigate('/blog')
      }, 1000);
    }else{
      showNotification('Error al eliminar la noticia', 'error');
    }

  }

  async function send(){
    // Use article owner id when editing to avoid changing the author
    const userId = id ? ownerId : context.user.id;
    setLoading(true);
    if(title === ''){
      showNotification('El campo titulo es obligatorio', 'error');
      setLoading(false);
      return;
    }else if(text === ''){
      showNotification('El campo texto es obligatorio', 'error');
      setLoading(false);
      return;
    }else if(!id && image === null){
      // The image is required only when creating a new article
      showNotification('El campo imagen es obligatorio', 'error');
      setLoading(false);
      return;
    }else if(serviceId === ''){
      showNotification('El campo servicio es obligatorio', 'error');
      setLoading(false);
      return;
    }
    let res;
    if(id){
      res = await endPoints.updateArticle(userId, id, title, text, image, serviceId);
    }else{
      res = await endPoints.createArticle(userId, title, text, image, serviceId);
    }
    if(res === null || res === undefined){
      showNotification(id ? 'Error al actualizar la noticia' : 'Error al crear la noticia', 'error');
      setLoading(false);
      return;
    }else{
      showNotification(id ? 'Noticia actualizada con exito' : 'Noticia creada con exito', 'success');
      setTimeout(() => {
        context.user.hasRole('admin') ? navigate('/admin/manageArticles') : navigate('employee/articles');
      }, 1000);
    }
    setLoading(false);
  }
  

  useEffect(() => {
    async function load() {
      setLoading(true);
      await getServices();
      if(id){
        const article = await endPoints.getArticle(id);
        setOwnerId(article.user_id);
        setTitle(article.title);
        setText(article.text);
        if (article.service) {
          setServiceId(article.service.id);
        }
      }
      setLoading(false);
    }
    load();
  }, [id])

  if (loading) return <Loader />;

    return (
      <>
      <Helmet>
        <title>Crear Artículo | CES</title>
        <meta name="description" content="Publica un nuevo artículo en el blog." />
      </Helmet>
      <Container sx={{ mt: 5, mb: 5, p: 2 }}>
         <Box sx={{ display:'flex', justifyContent:'flex-end', mb:2 }}>
          <Button variant="contained" startIcon={<ArrowBackIcon />} onClick={() => navigate(-1)}>Volver</Button>
        </Box>
      <Paper sx={{ p: 3 }}>
       
        <Typography variant="h5" >{id ? 'Actualizar Artículo' : 'Crear Artículo'}</Typography>
        <Grid container spacing={3}  sx={{ my: 3 }} alignItems='center' justifyContent='center'>
                     {/* {messageError  !== '' && <ErrorAlert message={messageError} />}
                     {messageSucess  !== '' && <SucessAlert message={messageSucess} />} */}
                    
          <Grid item xs={12} md={10} justifyContent='center'>
            <Input value={title !== ''? title : ''} sx={{ width: '100%' }} onChange={(e) => setTitle(e.target.value)} placeholder="Titulo" autoFocus />
          </Grid>
          <Grid item xs={12} md={10} justifyContent='center'>
            <Input type="file" accept='image/*' onChange={(e) => setImage(e.target.files[0])} />
          </Grid>
          <Grid item xs={12} md={10} justifyContent='center'>
          <Autocomplete
            options={services}
            value={services.find(serv => String(serv.id) === String(serviceId)) || null}
            onChange={(_event, newValue) => setServiceId(newValue ? newValue.id : '')}
            getOptionLabel={option => option.name || option.title || ''}
            isOptionEqualToValue={(option, value) => String(option.id) === String(value.id)}
            renderInput={params => (
              <TextField {...params} label="Servicio" fullWidth />
            )}
          />
          </Grid>
          <Grid item xs={12} md={10} justifyContent='center'>
            <TextField
              value={text !== '' ? text : ''}
              onChange={(e) => setText(e.target.value)}
              variant='standard'
              placeholder='Texto de la noticia'
              multiline
              minRows={3}
              fullWidth
            />
          </Grid>
          <Grid item xs={12} justifyContent='center'>
            <Grid container spacing={2} justifyContent='space-around' alignItems='center'>
              <Grid item xs={12} md={4}>
                <Button variant="contained" sx={{ width: '100%' }} onClick={()=>{send()}}>
                  {id? 'Editar' : 'Publicar'}
                </Button>
              </Grid>

              {context.user.canDeleteArticle(ownerId) && <Grid item xs={12} md={4}>
                <Button variant="contained" sx={{ width: '100%' }} onClick={(event) =>{deleteArticle()}}>
                  Eliminar
                </Button>
              </Grid>}
            </Grid>
          </Grid>
          </Grid>
          </Paper>
          </Container>
      </>

    )
  }
  
  export default CreateArticle;
